import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import Logo from '../components/svg/Logo';
import ArrowRight from '../components/svg/ArrowRight';

const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const flow = searchParams.get('flow');
  const isSignup = flow === 'signup';

  return (
    <AuthLayout>
      <div className="w-full flex flex-col items-center justify-center px-[52px] py-6 lg:py-[20px] lg:px-[24px] font-['DM_Sans',sans-serif]">
        <div className="w-full max-w-full sm:max-w-[400px] md:max-w-[480px] xl:max-w-[500px] flex flex-col items-center">
          <div className="text-center mb-[33px] lg:mb-[38px]">
            <Logo className="w-[160px] lg:w-[187px] h-auto object-contain" />
          </div>

          <div className="premium-card dark-blue-tint relative z-10 w-full p-[30px] sm:p-[35px] bg-white rounded-[24px] shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
            <Result
              status="error"
              title={<span className="font-['Lexend',sans-serif] text-[20px] text-[#1f2a37] font-semibold">Payment Failed</span>}
              subTitle={<span className="font-['Lexend',sans-serif] text-[14px] text-[#555d67]">Your payment could not be processed.<br/>Please try again.</span>}
              extra={[
                <div className="flex justify-center mt-6" key="dashboard">
                  <Button
                    onClick={() => navigate(isSignup ? '/signup' : '/')}
                    className="inline-flex items-center justify-center gap-2.5 sm:gap-2.5 lg:gap-[15px] h-auto min-h-[36px] sm:min-h-[38px] md:min-h-[44px] lg:min-h-[44px] px-1.5 py-1.5 sm:px-1.5 md:px-2 md:py-2 rounded-[20px] bg-[#4682b4] hover:!bg-[#4682b4] hover:!text-white hover:-translate-y-0.5 active:translate-y-0 border-none text-[12px] sm:text-[13px] lg:text-[16px] font-normal font-['Lexend',sans-serif] text-white leading-none cursor-pointer transition-all duration-300 shadow-[0_4px_12px_rgba(70,130,180,0.3)]"
                  >
                    <div className="flex items-center justify-center w-[22px] h-[22px] md:w-[29px] md:h-[29px] bg-white border-[1.5px] border-[#4682b4] rounded-full shrink-0 [&>svg]:w-[10px] [&>svg]:h-[10px] md:[&>svg]:w-auto md:[&>svg]:h-auto">
                      <ArrowRight />
                    </div>
                    <span className="pr-[15px] md:pr-[27px]">
                      {isSignup ? 'Go to Sign Up' : 'Go to Dashboard'}
                    </span>
                  </Button>
                </div>
              ]}
            />
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default PaymentFailed;
